(function () {
    "use strict";

    // Typed class - handles the typewriter animation logic
    function Typed(element, options, textContent) {
        var defaults = {
            typeSpeed: 0,
            startDelay: 0,
            showCursor: true,
            hideCursorOnComplete: false,
            onComplete: function () {},
            checkTextClipping: function () {},
        };

        this.element = element;
        this.options = angular.extend({}, defaults, options);
        this.textContent = element.textContent
            ? element.textContent.trim()
            : "";
        this.strPos = 0;
        this.typingComplete = false;
        this.textContent = textContent;
        this.element.innerHTML = "";
        this.appendAnimationCss();
    }

    Typed.prototype.begin = function () {
        if (this.typingComplete) {
            return this.restart();
        }

        this.insertCursor();

        this.timeout = setTimeout(
            angular.bind(this, function () {
                this.typewrite();
            }),
            this.options.startDelay
        );
    };

    Typed.prototype.typewrite = function () {
        var humanize = this.humanizer(this.options.typeSpeed);

        this.timeout = setTimeout(
            angular.bind(this, function () {
                this.toggleBlinking(false);

                if (this.strPos >= this.textContent.length) {
                    this.doneTyping();
                } else {
                    this.keepTyping();
                }

                // Check if the text is clipped (i.e., more than n lines)
                this.options.checkTextClipping();
            }),
            humanize
        );
    };

    Typed.prototype.keepTyping = function () {
        if (this.strPos === 0) {
            this.toggleBlinking(false);
        }

        this.strPos += 1;
        var nextString = this.textContent.substr(0, this.strPos);
        if (
            this.textContent[this.strPos - 1] === "<" &&
            this.textContent.indexOf(">", this.strPos) !== -1
        ) {
            var closeTagIndex = this.textContent.indexOf(">", this.strPos) + 1;
            nextString = this.textContent.substr(0, closeTagIndex);
            this.strPos += closeTagIndex - this.strPos;
        }
        this.replaceText(nextString);

        if (this.shouldScroll()) {
            this.smoothScrollToElement();
        }
        this.typewrite();
    };

    Typed.prototype.doneTyping = function () {
        this.toggleBlinking(true);

        if (this.textContent.length === this.strPos) {
            this.complete();
        }
    };

    Typed.prototype.complete = function () {
        if (this.options.hideCursorOnComplete) {
            this.removeCursor();
        }
        this.typingComplete = true;
        this.options.onComplete();
    };

    Typed.prototype.hideCursor = function () {
        if (this.cursor) {
            this.cursor.style.display = "none";
        }
    };

    Typed.prototype.showCursor = function () {
        if (this.cursor) {
            this.cursor.style.display = "inline";
        }
    };

    Typed.prototype.shouldScroll = function () {
        var parentHeight = window.innerHeight;
        if (this.options.useParentHeight && this.element.parentElement) {
            var parentRect = this.element.parentElement.getBoundingClientRect();
            parentHeight = parentRect.height;
        }

        return this.element.getBoundingClientRect().height + 50 > parentHeight;
    };

    Typed.prototype.smoothScrollToElement = function () {
        var self = this;
        requestAnimationFrame(function () {
            try {
                self.element.scrollIntoView({
                    block: "end",
                    inline: "nearest",
                    behavior: "smooth",
                });
            } catch (e) {
                self.element.scrollIntoView();
            }
        });
    };

    Typed.prototype.restart = function () {
        if (!this.typingComplete) {
            return;
        }

        clearTimeout(this.timeout);
        this.replaceText("");

        this.removeCursor();

        this.strPos = 0;
        this.typingComplete = false;
        this.begin();
    };

    Typed.prototype.insertCursor = function () {
        if (this.cursor) {
            return;
        }

        this.cursor = document.createElement("span");
        this.cursor.className = "typed-cursor";
        this.cursor.style.cssText =
            "opacity: 1; display: inline; width: auto; height: 1em; color: #000; font-weight: bold; margin-left: 2px; vertical-align: baseline; position: relative; top: 0; left: 0; animation: typedjsBlink 1s infinite; -webkit-animation: typedjsBlink 1s infinite;";

        this.positionCursorAtEnd();
    };

    Typed.prototype.removeCursor = function () {
        if (this.cursor && this.cursor.parentNode) {
            this.cursor.parentNode.removeChild(this.cursor);
            this.cursor = null;
        }
    };

    Typed.prototype.replaceText = function (str) {
        var cursorExists = this.cursor && this.cursor.parentNode;
        this.element.innerHTML = str;
        if (cursorExists && this.cursor) {
            this.positionCursorAtEnd();
        }
    };

    Typed.prototype.positionCursorAtEnd = function () {
        if (!this.cursor) return;

        if (this.cursor.parentNode) {
            this.cursor.parentNode.removeChild(this.cursor);
        }
        var lastTextNode = this.findLastTextNode(this.element);

        if (lastTextNode) {
            lastTextNode.parentNode.insertBefore(
                this.cursor,
                lastTextNode.nextSibling
            );
        } else {
            this.element.appendChild(this.cursor);
        }
    };

    Typed.prototype.findLastTextNode = function (element) {
        var lastTextNode = null;

        function traverse(node) {
            if (node.nodeType === Node.TEXT_NODE && node.textContent.trim()) {
                lastTextNode = node;
            }
            for (var i = 0; i < node.childNodes.length; i++) {
                traverse(node.childNodes[i]);
            }
        }

        traverse(element);
        return lastTextNode;
    };

    Typed.prototype.humanizer = function (speed) {
        return Math.round((Math.random() * speed) / 2) + speed;
    };

    Typed.prototype.toggleBlinking = function (isBlinking) {
        if (!this.cursor) {
            return;
        }

        if (this.cursorBlinking === isBlinking) {
            return;
        }

        this.cursorBlinking = isBlinking;
        var status = isBlinking ? "infinite" : 0;
        this.cursor.style.animationIterationCount = status;
    };

    Typed.prototype.appendAnimationCss = function () {
        if (this.options.showCursor) {
            if (document.head.querySelector("#typing")) {
                return;
            }

            var css = document.createElement("style");
            css.type = "text/css";
            css.id = "typing";

            var innerCss =
                ".typed-cursor{" +
                "opacity: 1;" +
                "border-right: 0.7em solid #000;" +
                "animation: typedjsBlink 1s infinite;" +
                "-webkit-animation: typedjsBlink 1s infinite;" +
                "animation: typedjsBlink 1s infinite;" +
                "}" +
                "@keyframes typedjsBlink{" +
                "50% { opacity: 0.0; }" +
                "}" +
                "@-webkit-keyframes typedjsBlink{" +
                "0% { opacity: 1; }" +
                "50% { opacity: 0.0; }" +
                "100% { opacity: 1; }" +
                "}";

            css.innerHTML = innerCss;
            document.head.appendChild(css);
        }
    };

    Typed.prototype.stop = function () {
        if (this.timeout) {
            clearTimeout(this.timeout);
        }

        this.replaceText(this.textContent.substr(0, this.strPos));
        this.removeCursor();

        this.typingComplete = true;
        this.toggleBlinking(false);

        if (this.options.onComplete) {
            this.options.onComplete();
        }
    };

    // AngularJS Directive
    function typeWriterDirective() {
        return {
            restrict: "A",
            scope: {
                typeSpeed: "=?",
                startDelay: "=?",
                condition: "=?",
                isShowAnimation: "=?",
                hideCursorOnComplete: "=?",
                text: "=?",
                useParentHeight: "=?",
                onComplete: "&?",
            },
            link: function (scope, element, attrs) {
                var SCROLL_HEIGHT_OFFSET = 30; // line-height is 28px
                var typed = null;
                var typingLock = false;
                var contentWatcher = null;

                scope.typeSpeed = scope.typeSpeed || 0;
                scope.startDelay = scope.startDelay || 0;
                scope.condition = scope.condition !== false;
                scope.isShowAnimation = scope.isShowAnimation !== false;
                scope.hideCursorOnComplete =
                    scope.hideCursorOnComplete || false;
                scope.text = scope.text || "";

                function checkContent() {
                    return scope.text;
                }

                function createTyped() {
                    if (!scope.isShowAnimation) {
                        return;
                    }

                    typed = new Typed(
                        element[0],
                        {
                            typeSpeed: scope.typeSpeed,
                            startDelay: scope.startDelay,
                            condition: scope.condition,
                            hideCursorOnComplete: scope.hideCursorOnComplete,
                            onComplete: function () {
                                if (scope.onComplete) {
                                    scope.$apply(function () {
                                        scope.onComplete();
                                    });
                                }
                                typingLock = false;
                            },
                            checkTextClipping: function () {
                                checkTextClipping();
                            },
                            showCursor: true,
                            useParentHeight: scope.useParentHeight,
                        },
                        scope.text
                    );

                    if (scope.condition) {
                        typed.begin();
                        typingLock = true;
                    }

                    checkTextClipping();
                }

                function checkTextClipping() {
                    var el = element[0];
                    var clientHeight = el.clientHeight;
                    var scrollHeight = el.scrollHeight;

                    if (scrollHeight > clientHeight + SCROLL_HEIGHT_OFFSET) {
                        stopTypingAnimation();
                    }
                }

                function stopTypingAnimation() {
                    if (typed) {
                        typed.stop();
                        typingLock = false;
                    }
                }

                // Initialize
                if (checkContent() && scope.isShowAnimation) {
                    createTyped();
                } else if (scope.isShowAnimation) {
                    // Watch for content to become available
                    contentWatcher = scope.$watch("text", function (newText) {
                        if (newText && !typed) {
                            createTyped();
                            contentWatcher(); // Unwatch
                        }
                    });
                }

                // Watch for condition changes
                scope.$watch(
                    "condition",
                    function (newCondition, oldCondition) {
                        if (!scope.isShowAnimation || !typed) return;
                        if (typingLock) return;

                        if (newCondition && newCondition !== oldCondition) {
                            typed.begin();
                            typingLock = true;
                        }
                    }
                );

                // Watch for text changes
                scope.$watch("text", function (newText, oldText) {
                    if (!scope.isShowAnimation || !typed) return;
                    if (typingLock) return;

                    if (newText && newText !== oldText && scope.condition) {
                        typed.textContent = newText;
                        typed.begin();
                        typingLock = true;
                    }
                });

                // Cleanup
                scope.$on("$destroy", function () {
                    if (contentWatcher) {
                        contentWatcher();
                    }
                    if (typed && typed.timeout) {
                        clearTimeout(typed.timeout);
                    }
                });
            },
        };
    }

    // Register the directive
    angular
        .module("atheer.core")
        .directive("appTypewriterAnimation", typeWriterDirective);
})();
